module.exports = __webpack_public_path__ + "static/media/Home.d2172916.jpg";